import React, { useEffect, useRef, useState } from 'react'
// import { Form, Field } from 'react-final-form'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
// import InputMask from 'react-input-mask'
// import isEmail from 'validator/lib/isEmail'
// InviteFormType
import { InitialState, TeacherItemType } from './types'
import { InitialState as ProfileInitialState } from '../SignInPage/types'

// Styles
import './styles.scss'

// Components
import Header from '../../components/Header'
import ProfileHeader from '../../components/ProfileHeader'
import Footer from '../../components/Footer'
// import Loading from '../../components/Loading'
import notification from '../../components/Notification'
import LoadingPage from '../../components/LoadingPage'
import Loading from '../../components/Loading'
import ModalInvite from '../../components/ModalInvite'
import AwardsEditBlock from '../../components/AwardsEditBlock'

// Icons
import IconTeacher_1 from './images/iconTeacher_1'
import IconTeacher_2 from './images/iconTeacher_2'
import IconTeacher_3 from './images/iconTeacher_3'
import IconTeacher_4 from './images/iconTeacher_4'
import IconCopy from '../../components/ProfileHeader/images/iconCopy'
import TeacherFemale from './images/teacherFemale'
import TeacherMale from './images/teacherMale'
import usePrevious from '../../hooks/usePrevious'

const EmptyTeacherItem = ({
  item,
}: {
  item: { icon: JSX.Element; title: string }
}) => {
  return (
    <div className={'profile-teachers__block-item'}>
      {item.icon}
      <div className={'name'}>{item.title}</div>
    </div>
  )
}

const TeacherItem = ({ item }: { item: TeacherItemType }) => {
  return (
    <div className={'profile-teachers__block-item'}>
      {item.gender ? (
        item.gender === 'female' ? (
          <TeacherFemale />
        ) : (
          <TeacherMale />
        )
      ) : (
        <IconTeacher_1 />
      )}
      <div className={'name'}>
        {item.last_name} {item.first_name} {item.middle_name}
        {item.short_id ? (
          <>
            <br />
            <span className={'name__code'}>ID {item.short_id}</span>
          </>
        ) : null}
      </div>
    </div>
  )
}

export default () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [teacherId, setTeacherId] = useState<string>('')
  const [modalInvite, setModalInvite] = useState<boolean>(false)

  const dispatch = useDispatch()

  // isProcessSendInvite
  const {
    teachers,
    isFetchingTeachers,
    isProcessTeacherConnect,
    inviteIsSend,
    error,
  } = useSelector(
    (state: { profileTeachers: InitialState }) => state.profileTeachers
  )

  const { certificates, isFetchingCertificates } = useSelector(
    (state: { profile: ProfileInitialState }) => state.profile
  )

  const isMounted = useRef<boolean>(false)
  const prevIsProcessTeacherConnect = usePrevious(isProcessTeacherConnect)
  const prevIsFetchingTeachers = usePrevious(isFetchingTeachers)
  const refInputId = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchTeachers())
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (inviteIsSend) {
      notification(<IconCopy />, '', 'Приглашение отправлено!')
    }
  }, [inviteIsSend])

  useEffect(() => {
    if (prevIsProcessTeacherConnect && !isProcessTeacherConnect) {
      if (error) {
        notification('error', '', error)
      } else {
        setTeacherId('')
        notification(<IconCopy />, '', 'Учитель добавлен!')
      }
    }
  }, [isProcessTeacherConnect])

  useEffect(() => {
    if (prevIsFetchingTeachers && !isFetchingTeachers && isMounted.current) {
      setIsLoaded(true)
    }
  }, [isFetchingTeachers])

  const emptyPlaceholder = [
    {
      icon: <IconTeacher_1 />,
      title: 'Твоего любимого учителя еще нет здесь :(',
    },
    {
      icon: <IconTeacher_2 />,
      title: 'С нами уже сотни учителей, а твоего нет :(',
    },
    {
      icon: <IconTeacher_3 />,
      title: 'Приглашай скорее своего классного руководителя!',
    },
    {
      icon: <IconTeacher_4 />,
      title: 'Где же твой учитель?',
    },
  ]

  // const required = (value: string) => (value ? undefined : 'error')
  // const requiredEmail = (value: string) =>
  //   isEmail(value || '') ? undefined : 'error'
  // const requiredPhone = (value: string) => {
  //   const formatPhone = value?.replace(/[^\d]/g, '')
  //   return formatPhone?.length === 11 ? undefined : 'error'
  // }
  //
  // const sendForm = (values: InviteFormType) => {
  //   values.contact_phone = values.contact_phone.replace(/[^\d]/g, '')
  //   dispatch(actions.sendInviteTeacher(values))
  // }

  const handleConnectTeacher = () => {
    if (teacherId) {
      dispatch(actions.connectTeacher(teacherId))
    } else if (refInputId.current) {
      refInputId.current?.focus()
    }
  }

  return (
    <>
      <Header />
      <div className={'profile'}>
        <div className={'container'}>
          <ProfileHeader style={{ marginBottom: 41 }} />
          {(!isMounted.current || isFetchingTeachers) && !isLoaded ? (
            <LoadingPage />
          ) : (
            <div className={'profile-teachers'}>
              <div className={'profile-teachers__block'}>
                <div className={'profile-teachers__block-title'}>
                  Список учителей
                </div>
                <div className={'profile-teachers__block-row'}>
                  {teachers && teachers.length ? (
                    <>
                      <div className={'left'}>
                        {teachers
                          .filter((_, index) => index % 2 === 0)
                          .map(item => (
                            <TeacherItem key={item.user_id} item={item} />
                          ))}
                      </div>
                      <div className={'hr'} />
                      <div className={'right'}>
                        {teachers
                          .filter((_, index) => index % 2 !== 0)
                          .map(item => (
                            <TeacherItem key={item.user_id} item={item} />
                          ))}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={'left'}>
                        {emptyPlaceholder
                          .filter((_, index) => index % 2 === 0)
                          .map((item, index) => (
                            <EmptyTeacherItem
                              key={`left-placeholder-${index}`}
                              item={item}
                            />
                          ))}
                      </div>
                      <div className={'hr'} />
                      <div className={'right'}>
                        {emptyPlaceholder
                          .filter((_, index) => index % 2 !== 0)
                          .map((item, index) => (
                            <EmptyTeacherItem
                              key={`right-placeholder-${index}`}
                              item={item}
                            />
                          ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className={'profile-teachers__additional'}>
                <div className={'profile-teachers__additional-item'}>
                  {/* <div className={'invite'}>*/}
                  {/*  <div className={'invite__title'}>Пригласить учителя</div>*/}
                  {/*  <Form*/}
                  {/*    onSubmit={sendForm}*/}
                  {/*    render={({ handleSubmit }) => (*/}
                  {/*      <form onSubmit={handleSubmit}>*/}
                  {/*        <div className={'invite__input'}>*/}
                  {/*          <span>Фамилия:</span>*/}
                  {/*          <Field*/}
                  {/*            component={'input'}*/}
                  {/*            name={'last_name'}*/}
                  {/*            validate={required}*/}
                  {/*          >*/}
                  {/*            {({ input, meta }) => (*/}
                  {/*              <input*/}
                  {/*                {...input}*/}
                  {/*                style={*/}
                  {/*                  meta.error === 'error' && meta.touched*/}
                  {/*                    ? { border: '1px solid red' }*/}
                  {/*                    : {}*/}
                  {/*                }*/}
                  {/*              />*/}
                  {/*            )}*/}
                  {/*          </Field>*/}
                  {/*        </div>*/}
                  {/*        <div className={'invite__input'}>*/}
                  {/*          <span>Имя:</span>*/}
                  {/*          <Field*/}
                  {/*            component={'input'}*/}
                  {/*            name={'first_name'}*/}
                  {/*            validate={required}*/}
                  {/*          >*/}
                  {/*            {({ input, meta }) => (*/}
                  {/*              <input*/}
                  {/*                {...input}*/}
                  {/*                style={*/}
                  {/*                  meta.error === 'error' && meta.touched*/}
                  {/*                    ? { border: '1px solid red' }*/}
                  {/*                    : {}*/}
                  {/*                }*/}
                  {/*              />*/}
                  {/*            )}*/}
                  {/*          </Field>*/}
                  {/*        </div>*/}
                  {/*        <div className={'invite__input'}>*/}
                  {/*          <span>Отчество:</span>*/}
                  {/*          <Field*/}
                  {/*            component={'input'}*/}
                  {/*            name={'middle_name'}*/}
                  {/*            validate={required}*/}
                  {/*          >*/}
                  {/*            {({ input, meta }) => (*/}
                  {/*              <input*/}
                  {/*                {...input}*/}
                  {/*                style={*/}
                  {/*                  meta.error === 'error' && meta.touched*/}
                  {/*                    ? { border: '1px solid red' }*/}
                  {/*                    : {}*/}
                  {/*                }*/}
                  {/*              />*/}
                  {/*            )}*/}
                  {/*          </Field>*/}
                  {/*        </div>*/}
                  {/*        <div className={'invite__title contacts'}>*/}
                  {/*          Контактные данные*/}
                  {/*        </div>*/}
                  {/*        <div className={'invite__input'}>*/}
                  {/*          <span>E-mail:</span>*/}
                  {/*          <Field*/}
                  {/*            component={'input'}*/}
                  {/*            name={'contact_email'}*/}
                  {/*            validate={requiredEmail}*/}
                  {/*          >*/}
                  {/*            {({ input, meta }) => (*/}
                  {/*              <input*/}
                  {/*                {...input}*/}
                  {/*                style={*/}
                  {/*                  meta.error === 'error' && meta.touched*/}
                  {/*                    ? { border: '1px solid red' }*/}
                  {/*                    : {}*/}
                  {/*                }*/}
                  {/*              />*/}
                  {/*            )}*/}
                  {/*          </Field>*/}
                  {/*        </div>*/}
                  {/*        <div className={'invite__input'}>*/}
                  {/*          <span>Телефон:</span>*/}
                  {/*          <Field*/}
                  {/*            component={'input'}*/}
                  {/*            name={'contact_phone'}*/}
                  {/*            validate={requiredPhone}*/}
                  {/*          >*/}
                  {/*            {({ input, meta }) => (*/}
                  {/*              <InputMask*/}
                  {/*                value={input.value}*/}
                  {/*                mask={'+7(999)999-99-99'}*/}
                  {/*                style={*/}
                  {/*                  meta.error === 'error' && meta.touched*/}
                  {/*                    ? { border: '1px solid red' }*/}
                  {/*                    : {}*/}
                  {/*                }*/}
                  {/*                onChange={input.onChange}*/}
                  {/*              />*/}
                  {/*            )}*/}
                  {/*          </Field>*/}
                  {/*        </div>*/}
                  {/*        <button*/}
                  {/*          disabled={isProcessSendInvite}*/}
                  {/*          type={'submit'}*/}
                  {/*          className={'invite__button'}*/}
                  {/*        >*/}
                  {/*          {isProcessSendInvite ? (*/}
                  {/*            <Loading*/}
                  {/*              style={{ margin: 0 }}*/}
                  {/*              color={'#FFF'}*/}
                  {/*              width={45}*/}
                  {/*              height={45}*/}
                  {/*            />*/}
                  {/*          ) : (*/}
                  {/*            'Пригласить учителя'*/}
                  {/*          )}*/}
                  {/*        </button>*/}
                  {/*      </form>*/}
                  {/*    )}*/}
                  {/*  />*/}
                  {/* </div>*/}
                  <button
                    className={'profile-teachers__additional-button'}
                    onClick={() => setModalInvite(true)}
                  >
                    Пригласить учителя
                  </button>
                  <AwardsEditBlock
                    certificates={certificates}
                    isLoading={isFetchingCertificates}
                    style={{ marginTop: 35 }}
                  />
                </div>
                <div className={'profile-teachers__additional-item'}>
                  <div className={'profile-teachers__id'}>
                    <div className={'profile-teachers__id-title'}>
                      Добавить учителя
                    </div>
                    <div className={'profile-teachers__id-row'}>
                      <label htmlFor={'teacher-id'}>id учителя:</label>
                      <input
                        value={teacherId}
                        className={'input'}
                        id={'teacher-id'}
                        ref={refInputId}
                        type={'text'}
                        onChange={event => setTeacherId(event.target.value)}
                        autoComplete={'off'}
                      />
                    </div>
                    <button
                      disabled={isProcessTeacherConnect}
                      onClick={handleConnectTeacher}
                      className={'profile-teachers__id-button'}
                    >
                      {isProcessTeacherConnect ? (
                        <Loading
                          style={{ margin: '10px 0' }}
                          width={47}
                          height={47}
                          color={'#FFF'}
                        />
                      ) : (
                        'Добавить учителя'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <ModalInvite
          modal={modalInvite}
          typeInvite={'learner'}
          isReverse={true}
          alertDescription={'Поделитесь ей с учителем!'}
          onClose={() => setModalInvite(false)}
          connectionType={'many-to-many'}
        />
      </div>
      <Footer />
    </>
  )
}
